import React from 'react';
import JobActionButton from '../../Jobs/JobActionButton';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import CcCluster from '../../../services/models/CcCluster';
import { ButtonProps } from 'antd/lib/button';
import ClusterCreateReplicationForm from './ClusterCreateReplicationForm';

export default ClusterCreateReplicationButton;

export type ClusterCreateReplicationButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function ClusterCreateReplicationButton({
    cluster,
    onSuccess,
    children,
    ...rest
}: ClusterCreateReplicationButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.CREATE_CLUSTER}
                    clusterId={cluster.clusterId}
                    extraKey={['replica']}
                    {...rest}
                >
                    {children || 'Create replica cluster'}
                </JobActionButton>
            }
            form={
                <ClusterCreateReplicationForm
                    cluster={cluster}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
